const headerTabs = document.querySelectorAll(".Drawer__header-item");
const sections = document.querySelectorAll(".SidebarMenu__Nav-content");
const submenuBtns = document.querySelectorAll(".subdrawer-tab-button");
const closeSubmenuBtns = document.querySelectorAll(".subdrawer-close-button");
const drawerButton = document.getElementById("open-siedebar-menu");
const sidebarMenu = document.getElementById("sidebar-menu");
const closeButton = document.getElementById("Drawer__Close-Icon");
const menuItems = document.querySelectorAll(
    '.HorizontalList__Item[aria-haspopup="true"]'
);
const openSdiebarMinicartButton = document.getElementById(
    "open-sidedar-minicar"
);
const closeSdiebarMinicartButton =
    document.getElementById("close-sidebar-cart");
const miniCart = document.getElementById("sidebar-cart");
const overlay = document.getElementById("drawer-overlay");

const originalFetch = window.fetch;
const variantCompareAtCache = new Map();

async function getVariantCompareAtPrice(item) {
    if (!item.handle || !item.variant_id) return 0;

    const cacheKey = `${item.handle}-${item.variant_id}`;

    if (variantCompareAtCache.has(cacheKey)) {
        return variantCompareAtCache.get(cacheKey);
    }

    try {
        const response = await originalFetch(`/products/${item.handle}.js`);

        if (!response.ok) {
            variantCompareAtCache.set(cacheKey, 0);
            return 0;
        }

        const product = await response.json();

        const variant = product.variants.find(
            (variant) => String(variant.id) === String(item.variant_id)
        );

        const compareAtPrice = Number(variant?.compare_at_price || 0);
        const realPrice = Number(variant?.price || item.final_price || item.price || 0);

        const finalCompareAtPrice = compareAtPrice > realPrice ? compareAtPrice : 0;

        variantCompareAtCache.set(cacheKey, finalCompareAtPrice);

        return finalCompareAtPrice;
    } catch (error) {
        console.error("Error obteniendo compare_at_price:", error);
        variantCompareAtCache.set(cacheKey, 0);
        return 0;
    }
}

window.openSidebar = function () {
    const sidebar = document.getElementById("sidebar-cart");
    const overlay = document.getElementById("drawer-overlay");

    if (!sidebar) return;
    actualizarCarrito();

    sidebar.classList.add("is-open");
    sidebar.setAttribute("aria-hidden", "false");
    sidebar.removeAttribute("inert");
    sidebar.style.pointerEvents = "auto";

    document.body.classList.add("body-no-scroll");

    if (overlay) overlay.classList.add("active");
};

window.closeSidebar = function () {
    const sidebar = document.getElementById("sidebar-cart");
    const overlay = document.getElementById("drawer-overlay");

    if (!sidebar) return;

    sidebar.classList.remove("is-open");
    sidebar.setAttribute("aria-hidden", "true");
    sidebar.style.pointerEvents = "none";

    document.body.classList.remove("body-no-scroll");

    if (overlay) overlay.classList.remove("active");
};

async function actualizarCarrito() {
    try {
        const response = await fetch("/cart.js");
        const data = await response.json();

        const minicartContainer = document.getElementById(
            "minicart-product-container"
        );

        if (!minicartContainer) return;

        minicartContainer.innerHTML = "";

        const formatter = new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: "MXN",
        });

        if (data.items.length === 0) {
            minicartContainer.innerHTML =
                '<p class="Cart__Empty Heading u-h5">Tu carrito está vacío</p>';
            return;
        }

        for (const item of data.items) {
            const compareAtUnitPrice = await getVariantCompareAtPrice(item);
            const compareAtLinePrice = compareAtUnitPrice * item.quantity;

            const currentLinePrice = item.final_line_price;

            const oldLinePrice = Math.max(
                item.original_line_price || 0,
                compareAtLinePrice || 0
            );

            const hasDiscount = oldLinePrice > currentLinePrice;

            const currentPrice = formatter.format(currentLinePrice / 100);
            const oldPrice = formatter.format(oldLinePrice / 100);

            const productHTML = `
                <div class="CartItem flex gap-4 py-3 border-b">
                    <div class="CartItem__ImageWrapper" style="flex-shrink:0;">
                        <img
                            class="CartItem__Image"
                            src="${item.image}"
                            alt="${item.product_title}"
                            width="90"
                            height="90"
                            loading="lazy"
                        >
                    </div>

                    <div class="CartItem__Details flex-1 flex flex-col justify-between">
                        <div>
                            <p class="CartItem__Title font-semibold text-sm leading-tight">
                                ${item.product_title}
                            </p>

                            <div class="CartItem__Prices">
                                <span class="CartItem__Price">${currentPrice}</span>

                                ${
                                    hasDiscount
                                        ? `<s class="CartItem__OldPrice text-xs text-gray-500">${oldPrice}</s>`
                                        : ""
                                }
                            </div>

                            ${
                                item.variant_title && item.variant_title !== "Default Title"
                                    ? `<p class="CartItem__Variant">${item.variant_title}</p>`
                                    : ""
                            }
                        </div>

                        <div class="CartItem__Bottom flex justify-between items-center mt-2">
                            <div 
                                class="CartItem__QuantityControl flex items-center gap-2" 
                                data-item-key="${item.key}"
                            >
                                <button 
                                    type="button" 
                                    class="CartItem__QtyBtn" 
                                    data-action="minus"
                                >
                                    −
                                </button>

                                <input 
                                    type="text" 
                                    readonly 
                                    value="${item.quantity}" 
                                    class="CartItem__QtyInput"
                                >

                                <button 
                                    type="button" 
                                    class="CartItem__QtyBtn" 
                                    data-action="plus"
                                >
                                    +
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            minicartContainer.insertAdjacentHTML("beforeend", productHTML);
        }

        attachMiniCartListeners();
    } catch (error) {
        console.error("Error al actualizar el carrito:", error);
    }
}

function hideSidebarMenu() {
    if (!sidebarMenu) return;
    sidebarMenu.setAttribute("aria-hidden", "false");
}

function closeSidebarMenu() {
    const sidebarMenu = document.getElementById("sidebar-menu");
    if (!sidebarMenu) return;
    sidebarMenu.setAttribute("aria-hidden", "true");
}

drawerButton?.addEventListener("click", () => {
    console.log("ksk");
    hideSidebarMenu();
});

closeButton?.addEventListener("click", () => {
    closeSidebarMenu();
});

function activateMainTab(index) {
    headerTabs.forEach((btn, i) => {
        btn.classList.toggle("current", i === index);
        sections[i].classList.toggle("selected", i === index);
    });
}

if (headerTabs.length > 0) activateMainTab(0);
headerTabs.forEach((btn, i) => {
    btn.addEventListener("click", () => activateMainTab(i));
});

submenuBtns.forEach((button) => {
    button.addEventListener("click", (event) => {
        const id = event.currentTarget.id; // el botón real
        const submenu = document.querySelector(`.${id}`);

        if (submenu) {
            submenu.classList.add("submenu-active");
        } else {
            console.warn(`No se encontró el submenu con clase .${id}`);
        }
    });
});

closeSubmenuBtns.forEach((button) => {
    button.addEventListener("click", (event) => {
        const dataAttr = event.currentTarget.getAttribute("data-submenu");
        const submenu = document.querySelector(`.${dataAttr}`);

        if (submenu) {
            submenu.classList.remove("submenu-active");
        } else {
            console.warn(`No se encontró el submenu con clase .${dataAttr}`);
        }
    });
});

function attachMiniCartListeners() {
    document
        .querySelectorAll(".CartItem__QuantityControl")
        .forEach((control) => {
            const itemKey = control.getAttribute("data-item-key");
            const input = control.querySelector(".CartItem__QtyInput");

            control.querySelectorAll(".CartItem__QtyBtn").forEach((btn) => {
                btn.addEventListener("click", async () => {
                    const action = btn.getAttribute("data-action");
                    let currentQty = parseInt(input.value);

                    if (action === "minus" && currentQty > 1) {
                        await updateCartItem(itemKey, currentQty - 1);
                    } else if (action === "plus") {
                        await updateCartItem(itemKey, currentQty + 1);
                    } else if (action === "minus" && currentQty === 1) {
                        await removeCartItem(itemKey);
                    }
                });
            });
        });
}

async function updateCartItem(itemKey, newQty) {
    await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: itemKey, quantity: newQty }),
    });
    await actualizarCarrito();
}

async function changeCartItemQuantity(itemKey, newQty) {
    const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: itemKey, quantity: newQty }),
    });
    await res.json();
    await actualizarCarrito();
}

async function removeCartItem(itemKey) {
    const cartItem = document
        .querySelector(`[data-item-key="${itemKey}"]`)
        ?.closest(".CartItem");
    if (cartItem) {
        cartItem.classList.add("fade-out");
        setTimeout(() => cartItem.remove(), 300);
    }
    await changeCartItemQuantity(itemKey, 0);
}

if (overlay) overlay.addEventListener("click", closeSidebar);

document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const formData = new FormData(form);
        const variantId = formData.get("id");
        const quantity = formData.get("quantity") || 1;

        await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantId, quantity }),
        });

        await actualizarCarrito();
        openSidebar();
    });
});

openSdiebarMinicartButton.addEventListener("click", () => {
    openSidebar();
});

closeSdiebarMinicartButton.addEventListener("click", () => {
    closeSidebar();
});

function actualizarBarraDeProgreso() {
    fetch("/cart.js")
        .then((response) => response.json())
        .then((data) => {
            let totalCart = (data.total_price / 100).toFixed(2);
            let objetivo = 799;
            let porcentaje = (totalCart / objetivo) * 100;
            let barraDeProgreso = document.querySelector(".progreso");
            let messageBar = document.getElementById("message-bar");
            let faltante = objetivo - totalCart;

            barraDeProgreso.style.transition = "width 0.5s ease-in-out";

            if (porcentaje >= 100) {
                barraDeProgreso.style.width = "100%";
                messageBar.innerHTML =
                    "Conseguiste el envío <span>¡GRATIS!</span>";
                barraDeProgreso.textContent = "100%";
            } else {
                barraDeProgreso.style.width = porcentaje + "%";
                messageBar.innerHTML = `Te faltan $ ${faltante} para obtener el envío <span>¡GRATIS!</span>`;
                barraDeProgreso.textContent = porcentaje.toFixed(0) + "%";
            }
        })
        .catch((error) => {
            console.error("Error al actualizar la barra de progreso:", error);
        });
}

window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    const cartEndpoints = [
        "/cart/add",
        "/cart/change",
        "/cart/update",
        "/cart/clear",
    ];

    if (
        typeof args[0] === "string" &&
        cartEndpoints.some((endpoint) => args[0].includes(endpoint))
    ) {
        actualizarBarraDeProgreso();
    }

    return response;
};

actualizarBarraDeProgreso();

menuItems.forEach((item) => {
    const submenu = item.querySelector(".MegaMenu, .DropdownMenu");
    if (!submenu) return;

    item.addEventListener("mouseenter", () => {
        submenu.setAttribute("aria-hidden", "false");
    });

    item.addEventListener("mouseleave", () => {
        submenu.setAttribute("aria-hidden", "true");
    });
});
